// Lucide Icons Mixin
// 自動在組件生命週期中重新初始化 icons
export default {
  mounted() {
    this.$nextTick(() => {
      if (window.lucide) {
        window.lucide.createIcons();
      }
    });
  },
  updated() {
    // DOM 更新後立即重新初始化 icons
    if (window.lucide) {
      window.lucide.createIcons();
    }
  },
};
